<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">车牌号码</span>
         <el-input
          placeholder="请输入关键词"
          v-model="conditions.plate"
          clearable
        >
        </el-input>
        <span class="fonints">会员卡号</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.sn"
          clearable
        >
        </el-input>
        <span class="fonints">RFID号码</span>
         <el-input
          style="width: 230px"
          placeholder="请输入关键词"
          v-model="conditions.rfid"
          clearable
        >
        </el-input>
        <button class="buttons" @click="selectlist">查询</button>
        <button class="buttons" @click="addrole = true">新增</button>
        <el-upload
          style="display: inline-block"
          action="#"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
          :http-request="uploadfile"
        >
          <button class="buttons" style="background: orange">上传文件</button>
        </el-upload>
      </div>
      <div class="componentSty_content_table">
        <el-table  height="80%" :data="arrlist.list" style="width: 100%; height: 80%">
           <el-table-column
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column prop="plate" label="车牌号码"> </el-table-column>
          <el-table-column prop="sn" label="会员卡号"> </el-table-column>
          <el-table-column prop="rfid" label="RFID号码"> </el-table-column>
          <el-table-column label="状态">
            <template v-slot="res">
              <span
                v-if="res.row.useStatus == 0"
                class="el_spanfontstyle"
                style="color: #fe5a24"
                >待审核</span
              >
              <span
                v-if="res.row.useStatus == 1"
                class="el_spanfontstyle"
                style="color: #13d168"
                >正常</span
              >
              <span
                v-if="res.row.useStatus == 2"
                class="el_spanfontstyle"
                style="color: #fe5a24"
                >审核未通过</span
              >
              <span
                v-if="res.row.useStatus == 3"
                class="el_spanfontstyle"
                style="color: #fe5a24"
                >停用</span
              >
              <span
                v-if="res.row.useStatus == 4"
                class="el_spanfontstyle"
                style="color: #fe5a24"
                >缺卡</span
              >
              <span
                v-if="res.row.useStatus == 5"
                class="el_spanfontstyle"
                style="color: #fe5a24"
                >代发卡</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="res">
              <span
                v-if="res.row.id"
                class="iconfont icon-shanchu"
                @click="deleitem(res.row.id)"
              ></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.list&&arrlist.list.length">
          <el-pagination
            :page-size="conditions.limit"
             layout="total,prev, pager,next, jumper"
            :total="arrlist.totalCount"
             :current-page="conditions.page"
            @current-change="gettuckcomblist"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加角色对话框 -->
    <m-dialog :isShow="addrole" @changeState="sendMsg" title="新增卡号">
      <div class="inForMsgBox">
        <div class="itemBox" style="width: 100%; height: 30px; margin: 20px 0">
          <span class="key" style="width: 21%; line-height: 30px"
            >会员号码</span
          >
          <div
            class="val"
            style="background: #f3f4f5; height: 30px; width: 80%; float: right"
          >
            <m-superIpt
              v-model.lazy="tuckcomb.sn"
              defaultInfo="请输入会员号码"
            ></m-superIpt>
          </div>
        </div>
        <div class="itemBox" style="width: 100%; height: 30px; margin: 20px 0">
          <span class="key" style="width: 21%; line-height: 30px">RFID号</span>
          <div
            class="val"
            style="background: #f3f4f5; height: 30px; width: 80%; float: right"
          >
            <m-superIpt
              v-model.lazy="tuckcomb.rfid"
              defaultInfo="请输入RFID号"
            ></m-superIpt>
          </div>
        </div>
      </div>
    </m-dialog>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import mDialog from "@/components/mDialog";
import mSuperIpt from "@/components/mSuperIpt";
import { antiShake } from "@/plugins/other.js";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      listitem: [{ name: "会员管理" }, { name: "卡库管理" }],
      conditions: {},
      arrlist: [],
      tuckcomb: {
        sn: "", //会员卡号
        rfid: "",
      },
      addrole: false,
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  components: {
    mTitle,
    mDialog,
    mSuperIpt,
  },
  created() {
    this.conditionsList[this.$route.path] ||
      this.createConditions({
        key: this.$route.path,
        val: { page: 1, limit: 20, order: "desc", sidx: "rfid" },
      });
    this.conditions = this.conditionsList[this.$route.path] || {
      page: 1,
      limit: 20,
      order: "desc",
      sidx: "rfid",
    };
    this.gettuckcomblist();
  },
  methods: {
    ...mapMutations(["createConditions"]),
    async gettuckcomblist(num) {
       typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/driver/rfid/list",
        "get",
        this.conditions
      );
      if (!data || data.code != 0) return this.$message.error("获取数据失败");
      this.arrlist = data.data;
    },
    async sendMsg(item) {
      if (item != "confirm") {
        this.tuckcomb.sn = "";
        this.tuckcomb.rfid = "";
        return (this.addrole = false);
      }
      let isok = !this.tuckcomb.rfid || !this.tuckcomb.sn;
      if (isok) return this.$message.error("必填项不能为空");
      const { data } = await this.$http(
        "api1",
        "/driver/rfid/savecard",
        "post",
        this.tuckcomb
      );
      if (data.code != 0) return this.$message.error("新增卡号失败");
      this.$message.success("新增卡号成功");
      this.tuckcomb.sn = "";
      this.tuckcomb.rfid = "";
      this.addrole = false;
    },
    deleitem(id) {
      this.$messageBox
        .confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http(
            "api1",
            "/driver/rfid/delete",
            "post",
            { ids: [id] }
          );
          if (!data || data.msg != "success")
            return this.$message.error("获取数据失败");
          this.$message.success("删除成功");
          this.gettuckcomblist();
        })
        .catch(err=>err);
    },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.gettuckcomblist();
      });
    },
    // 上传文件前钩子
    beforeAvatarUpload(file) {
      let type =
          file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        size = file.size / 1024 / 1024 < 30;
      if (!type) {
        this.$message.error("请选择excel文件");
        return false;
      }
      if (!size) {
        this.$message.error("上传大小不能超过30M");
        return false;
      }
      return type && size;
    },
    // 上传文件
    async uploadfile(res) {
      const file = new FormData();
      file.append("multipartFile", res.file);
      file.append('flag', "357779a88b0b5ab0c9b2b061cac69672");
      const { data } = await this.$http(
        "api1",
        "/driver/rfid/uploadFileAndImportData",
        "post",
        file
      );
      if(data.code!=0) return this.$message.error(data.msg);
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>